export default "__VITE_ASSET__qVKYA_tV__"